import type { MessageAlternativesResponse } from '@/types/api'
import { getActiveVariant, variantFromAlternative, variantFromMessage, type MessageSlot } from '@/lib/messageSlots'
import { reconcileResponseVariant } from '@/features/story-conversation/responseState'

/** Server originals are distinct from the selected-content timeline projection.
 * Pending browser variants survive reads and keep their local selection.
 */
export function reconcileRoleplayAlternatives(slot: MessageSlot, response: MessageAlternativesResponse): void {
  const prior = slot.variants
  const active = getActiveVariant(slot)
  const pending = prior.filter(variant => variant.saveState)
  const saved = [response.original ? variantFromMessage(response.original) : prior[0],
    ...response.alternatives.map(variantFromAlternative)]
  const variants = saved.map(variant => {
    const local = prior.find(item => String(item.id) === String(variant.id)) ?? pending.find(item =>
      item.stream_id && item.stream_id === variant.stream_id)
    return reconcileResponseVariant(local?.saveState ? {
      ...variant, saveState: local.saveState, saveRequestId: local.saveRequestId,
    } : variant, local)
  })
  for (const variant of pending) {
    if (!variants.some(item => item.saveRequestId === variant.saveRequestId)) variants.push(variant)
  }
  slot.variants = variants
  slot.activeVariantId = active.saveState
    ? variants.find(variant => variant.saveRequestId === active.saveRequestId)?.id ?? active.id
    : response.active_variant_id ?? variants[0].id
}
